<template>
	<div class="popup-info">
		<div class="popup-info__content">
			<h3 class="popup-info__title popup__title">
				1. ПОВТОРИ В FIFA 18 ЛЮБОЙ ЗНАМЕНИТЫЙ ГОЛ<br> ИЗ ФУТБОЛЬНОЙ ИСТОРИИ<br>
				2. ПРИШЛИ НАМ ССЫЛКУ НА ВИДЕО<br>
				3. И НЕ ЗАБУДЬ УКАЗАТЬ КОМАНДЫ И ДАТУ ЭТОГО МАТЧА.
			</h3>
			<router-link to="/profile" class="btn" v-if="!isGuest">ДАЛЕЕ</router-link>
			<a href="javascript:void(0);" class="btn guest" v-else @click="showAuthPopup">Авторизоваться</a>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Info',
		computed: {
			isGuest() {
				return this.$store.getters['isGuest']
			}
		},
		methods: {
			closePopup() {
				this.$store.commit('SET_POPUP', {name: false});
			},
			showAuthPopup() {
				this.$store.commit('SET_POPUP', {name: false});
				setTimeout(() => {
					this.$store.commit('SET_POPUP', {name: 'Auth'});
				}, 800);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Info.vue?53b93327